export default __webpack_public_path__ + "static/media/kn.84087585.svg";